import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcMessage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M30 6v20H2V6h28Zm-2 2.908-12 8.308L4 8.91V24h24V8.908ZM25.796 8H6.202l9.797 6.783L25.796 8Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgIcMessage;
